import React, {Fragment, useRef, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const Checkbox: (props: any) => JSX.Element = (props: any) => {

    const [checked, setChecked] = useState<boolean>(false);
    const input = useRef<HTMLInputElement>(null);
    const {label, required, name} = props;

    const handleClick = () => {
        setChecked(!checked);
    }

    return (
        <Fragment>
            <div className="flex flex-row gap-5 items-center cursor-pointer" onClick={() => handleClick()} >
                <div className={`${checked ? 'bg-pomegranate-950' : 'bg-pomegranate-100 '} text-white min-w-[30px] w-[30px] h-[30px] flex items-center justify-center rounded-full drop-shadow transition-all`}>
                    {checked &&
                        <FontAwesomeIcon icon={icon({name: 'check'})} />
                    }
                </div>
                <div className="hidden">
                    <input ref={input} type="checkbox" name={name} value="1" required={required} checked={checked} onChange={() => {}} />
                </div>
                {label &&
                    <div className="leading-0 pointer-events-none">
                        {label}
                    </div>
                }
            </div>
        </Fragment>
    );
}

export default Checkbox;
